<template>
  <van-overlay :show="visible">
    <div class="popup">
      <div class="popup-main">
        <div class="popup-main-close">
          <van-icon
            @click="clickClose"
            name="close"
            color="white"
            size="30px" />
        </div>
        <template v-if="backgroundImg && backgroundImg.length > 0">
          <img
            class="popup-main-body mt-10"
            :src="backgroundImg"
            @click="clickCommitJoin" />
        </template>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { Overlay, Icon } from "vant"

export default {
  name: "LotteryPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activityType: 0, // 活动类型 1卡卷活动 2奖票活动 3积分活动
    backgroundImg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("onClose", "update:visible", false)
    },
    clickCommitJoin() {
      if (this.activityType == 1) {
        this.$emit("enterLottery")
      } else {
        this.$emit("lookRule")
      }
    }
  }
}
</script>

<style lang="less" scoped>
.popup {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  .popup-main {
    overflow: hidden;
    background-color: transparent;
    width: 300px;
    .popup-main-close {
      display: flex;
      justify-content: flex-end;
    }
    .popup-main-body {
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>
